import { useQuery } from '@tanstack/react-query';
import type { HotelReviewDto } from '@pms/shared';
import { getHotelReviews } from '../services/api/stories.api';

/**
 * Curated hotelier testimonials (TASK-62) for the homepage band (no propertyId)
 * or a property detail page (with propertyId). Reads GET /v1/public/reviews —
 * approved-property + active rows only. Consumers fall back to static
 * `TESTIMONIALS` when the result is empty or the request fails (R5).
 */
export function useHotelReviews(propertyId?: string) {
  return useQuery<HotelReviewDto[]>({
    queryKey: ['hotel-reviews', propertyId ?? 'home'],
    queryFn: () => getHotelReviews(propertyId),
    staleTime: 60 * 1000,
  });
}
